<footer id="footer" class="footer">
  @if (euribor) {
    <div class="container header-footer">
      <h2 class="h-main h-main-medium text-center">
        {{ 'footer_title' | translate }}
      </h2>
      <p class="footer-text">
        {{
          'footer_msg'
            | translate
              : {
                  euribor: euribor?.currentMonth !== '-' ? euribor?.currentMonth : 'NO DISPONIBLE',
                }
        }}
      </p>
    </div>
    <div class="container">
      <div [innerHTML]="'footer_info_1_mortgage_product_postpone' | translate: euribor"></div>
      <div [innerHTML]="'footer_info_2_mortgage_product_postpone' | translate: euribor"></div>
      <div [innerHTML]="'footer_info_3_mortgage_product_postpone' | translate: euribor"></div>
    </div>
  }
</footer>
